const e = { "logged-ticket-private": "{{name}} registró esto", view: "Ver", "view-ticket": "Ver ticket", meeting: "Reunión", "shared-private": "{{name}} compartió esto", "logged-ticket-public": "{{name}} registró esto", "shared-public": "{{name}} registró esto", "crated-meeting-public": "{{name}} ha compartido una reunión", "crated-meeting-private": "{{name}} creó una reunión" }, t = { ticketing: "Gestión de tickets", messaging: "Mensajería" }, i = {
  link: e,
  category: t
};
export {
  t as category,
  i as default,
  e as link
};
